import { render, staticRenderFns } from "./EditAndCreateHotkey.vue?vue&type=template&id=ae9bf9ae"
import script from "./EditAndCreateHotkey.vue?vue&type=script&lang=js"
export * from "./EditAndCreateHotkey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports